import { createConsumer } from "@rails/actioncable"

document.addEventListener("turbo:load", () => {
  const articleRoot = document.getElementById("article-root");

  if (articleRoot) {
    const locale = articleRoot.dataset.locale;
    const articleSlug = articleRoot.dataset.articleSlug;

    createConsumer().subscriptions.create(
      {
        channel: "YutoCmnt::Channels::CommentChannel",
        locale,
        article_slug: articleSlug
      },
      {
        connected() {
          console.log("Connected to CommentChannel");
        },
        received(data) {
          Turbo.renderStreamMessage(data);
        }
      }
    );
  }
})